(() => {
  const railStep = (rail) => Math.max(rail.clientWidth * 0.9, 1);

  const initRail = (section) => {
    const rail = section.querySelector('[data-fizo-blog-rail]');
    const previous = section.querySelector('[data-fizo-blog-rail-prev]');
    const next = section.querySelector('[data-fizo-blog-rail-next]');

    if (!rail || !previous || !next || rail.dataset.fizoBlogRailReady === 'true') return;
    rail.dataset.fizoBlogRailReady = 'true';

    const updateControls = () => {
      const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previous.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= maximum - 4;
    };

    previous.addEventListener('click', () => {
      rail.scrollBy({left: -railStep(rail), behavior: 'smooth'});
    });
    next.addEventListener('click', () => {
      rail.scrollBy({left: railStep(rail), behavior: 'smooth'});
    });
    rail.addEventListener('scroll', updateControls, {passive: true});
    window.addEventListener('resize', updateControls, {passive: true});
    updateControls();
  };

  const init = () => {
    document.querySelectorAll('[data-fizo-blog]').forEach((root) => {
      if (root.dataset.fizoBlogReady === 'true') return;
      root.dataset.fizoBlogReady = 'true';

      const top = root.querySelector('[data-fizo-blog-top]');
      const navigation = root.querySelector('[data-fizo-blog-nav]');
      const buttons = [...root.querySelectorAll('[data-fizo-blog-target]')];
      const sections = [...root.querySelectorAll('[data-fizo-blog-category]')];

      const setActive = (target) => {
        buttons.forEach((button) => {
          const active = button.dataset.fizoBlogTarget === target;
          button.classList.toggle('is-active', active);
          if (active) {
            button.setAttribute('aria-current', 'page');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      };

      // Keep the landing state anchored to the all-categories view before any scroll-driven updates.
      setActive('all');

      let scrollFrame = 0;
      let isProgrammaticCategoryScroll = false;
      let programmaticScrollTimeout = 0;

      const updateActiveFromScrollPosition = () => {
        scrollFrame = 0;
        if (isProgrammaticCategoryScroll) return;

        const activationLine = window.innerHeight * 0.35;
        const activeSection = sections.reduce((current, section) => (
          section.getBoundingClientRect().top <= activationLine ? section : current
        ), null);
        setActive(activeSection ? activeSection.id : 'all');
      };

      const queueActiveFromScrollPosition = () => {
        if (isProgrammaticCategoryScroll || scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(updateActiveFromScrollPosition);
      };

      const releaseProgrammaticCategoryScroll = () => {
        window.clearTimeout(programmaticScrollTimeout);
        programmaticScrollTimeout = window.setTimeout(() => {
          isProgrammaticCategoryScroll = false;
          queueActiveFromScrollPosition();
        }, 180);
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.fizoBlogTarget;
          const destination = target === 'all' ? top : document.getElementById(target);
          if (!destination) return;

          isProgrammaticCategoryScroll = true;
          destination.scrollIntoView({behavior: 'smooth', block: 'start'});
          setActive(target);
          releaseProgrammaticCategoryScroll();
        });
      });

      if (top && navigation && 'IntersectionObserver' in window) {
        const stickyObserver = new IntersectionObserver(
          ([entry]) => navigation.classList.toggle('is-bottom-sticky', !entry.isIntersecting),
          {threshold: 0}
        );
        stickyObserver.observe(top);
      }

      if (navigation && 'IntersectionObserver' in window) {
        const footer = document.querySelector('[data-footer-reveal-root]');
        if (footer) {
          const footerObserver = new IntersectionObserver(
            ([entry]) => navigation.classList.toggle('is-footer-visible', entry.isIntersecting),
            {threshold: 0}
          );
          footerObserver.observe(footer);
        }
      }

      const syncCategoryStateOnScroll = () => {
        if (isProgrammaticCategoryScroll) {
          releaseProgrammaticCategoryScroll();
          return;
        }
        queueActiveFromScrollPosition();
      };
      window.addEventListener('scroll', syncCategoryStateOnScroll, {passive: true});
      window.addEventListener('resize', queueActiveFromScrollPosition, {passive: true});
      updateActiveFromScrollPosition();

      sections.forEach(initRail);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
